import styled from 'styled-components';
import { colorList } from 'utils';
interface ColorDropdownProps {
  onColorSelect: (color: string) => void;
}
const ColorDropdown = (props: Partial<ColorDropdownProps>) => {
  return (
    <ColorInner>
      {colorList.map((i, index) => (
        <div
          key={index}
          style={{
            width: 35,
            height: 35,
            background: i,
            border: 'none',
            borderTopLeftRadius: index === 0 && 5,
            borderTopRightRadius: index === 7 && 5,
            borderBottomLeftRadius: index === 32 && 5,
            borderBottomRightRadius: index === 39 && 5,
          }}
          onClick={(e) => {
            e.preventDefault();
            props.onColorSelect(i);
          }}
        />
      ))}
    </ColorInner>
  );
};

const ColorInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 300px;
  height: 175px;
  padding: 3px 0 0 10px;
`;
export default ColorDropdown;
